import React from 'react';
import './UserDashboardData.scss';
const UserDashboardData = () => {
    return (
        <div className="w-100 SubParentDesign">
           <div className="d-flex align-items-center justify-content-center">
                <h2 className="mt-5 pt-5" style={{color:'#050545'}}>Welcome To The User Dashboard</h2>
            </div>
        </div>
    );
};
export default UserDashboardData;